import { Accordion, AccordionDetails, AccordionSummary, Link, Stack } from '@packages/shared';
import { ArrowMediumDown32, Mail32 } from '@packages/themes/icons';
import type { MouseEventHandler } from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../PromotionBanner.messages';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { Promotion } from '../types';

export const PromotionAccordionTemplate = ({
  summaryContent,
  toggleFunction,
  detailscontent,
  isExpanded,
  defaultExpanded,
  isPaybackPromotion = false,
}: {
  summaryContent: string;
  toggleFunction?: MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
  detailscontent: JSX.Element;
  isExpanded?: boolean;
  defaultExpanded?: boolean;
  isPaybackPromotion?: Promotion['isPaybackPromotion'];
}) => {
  const { formatMessage } = useIntl();
  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      sx={{ bgcolor: 'inherit', color: 'inherit' }}
      expanded={isExpanded ?? undefined}
      defaultExpanded={defaultExpanded ?? undefined}
    >
      <AccordionSummary
        expandIcon={
          <ArrowMediumDown32
            sx={{ color: isPaybackPromotion ? 'text.light' : 'primary.contrastText' }}
          />
        }
        sx={{ textAlign: 'center', flexGrow: 0, '& > div': { flexGrow: 0 } }}
        onClick={toggleFunction}
      >
        <span data-testid={PromotionBannerTestIds.title}>{summaryContent}</span>
      </AccordionSummary>
      <AccordionDetails data-testid={PromotionBannerTestIds.content}>
        {detailscontent}
        <Stack
          sx={{ borderTop: '1px solid #fff', paddingTop: 2, marginTop: 4 * 0.9 }}
          spacing={2}
          alignItems="center"
        >
          <Mail32 />
          <Link
            href={formatMessage(messages.newsletterSubscribeLink)}
            variant="body2"
            color="inherit"
            underline="hover"
            onClick={toggleFunction}
          >
            {formatMessage(messages.newsletterTeaserText)}
          </Link>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
